import LinearProgress from '@mui/material/LinearProgress';
import React from 'react';

const LinearProgressCustom = ({ value }) => {
  return (
    <div className='flex w-full items-center gap-1'>
      <div className='w-full'>
        <LinearProgress variant='determinate' value={value} />
      </div>
      <span className='text-primary'>{`${Math.round(value)}%`}</span>
    </div>
  );
};

export default LinearProgressCustom;
